<!-- Container-fluid starts-->
<div class="container-fluid">
    <div class="row">
        <div class="col-sm-12">
            <div class="card">
                <div class="card-body">
                    <ng-template #licenseContent let-modal>
                        <div class="modal-header">
                          <h4 class="modal-title" id="modal-basic-title">
                            {{ mode === 'add' ? 'Add License' : 'Edit License' }}
                          </h4>
                          <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
                        </div>
                        <div class="modal-body">
                          <form class="theme-form professional-form" [formGroup]="licenceUserForm">
                            
                            <!-- Logo Upload Section -->
                            <div class="form-group logo-upload-section">
                              <label class="form-label">Company Logo</label>
                              <div class="logo-preview-container">
                                <img class="logo-preview" [src]="previewLogo || 'assets/images/user/1.jpg'" alt="Company Logo">
                                <div class="logo-upload-overlay">
                                  <label class="upload-btn">
                                    <i class="fa fa-camera"></i>
                                    <span>Upload Logo</span>
                                    <input class="d-none" type="file" accept="image/*" (change)="readUrl($event)" />
                                  </label>
                                </div>
                              </div>
                            </div>

                            <div class="row g-3">
                              <!-- Company Name -->
                              <div class="col-md-6">
                                <div class="modern-form-group">
                                  <label for="companyName" class="modern-label">
                                    <i class="fa fa-building"></i> Company Name
                                  </label>
                                  <input class="form-control modern-input" type="text" placeholder="Enter your company name" formControlName="companyName" id="companyName" />
                                  <div *ngIf="licenceUserForm.controls['companyName'].touched && licenceUserForm.controls['companyName'].errors?.['required']" class="invalid-feedback d-block">
                                    Company Name is required
                                  </div>
                                </div>
                              </div>

                              <!-- Company Code -->
                              <div class="col-md-6">
                                <div class="modern-form-group">
                                  <label for="companyCode" class="modern-label">
                                    <i class="fa fa-code"></i> Company Code
                                  </label>
                                  <input class="form-control modern-input" type="text" placeholder="Enter unique company code" formControlName="companyCode" id="companyCode" />
                                  <div *ngIf="licenceUserForm.controls['companyCode'].touched && licenceUserForm.controls['companyCode'].errors?.['required']" class="invalid-feedback d-block">
                                    Company Code is required
                                  </div>
                                </div>
                              </div>
                    
                              <!-- Admin Email -->
                              <div class="col-md-6">
                                <div class="modern-form-group">
                                  <label for="companyEmail" class="modern-label">
                                    <i class="fa fa-envelope"></i> Admin Email
                                  </label>
                                  <input class="form-control modern-input" type="email" placeholder="admin@company.com" formControlName="companyEmail" id="companyEmail" />
                                  <div *ngIf="licenceUserForm.controls['companyEmail'].touched && licenceUserForm.controls['companyEmail'].errors?.['required']" class="invalid-feedback d-block">
                                    Email is required
                                  </div>
                                </div>
                              </div>
                    
                              <!-- License Type -->
                              <div class="col-md-6">
                                <div class="modern-form-group">
                                  <label for="licenseType" class="modern-label">
                                    <i class="fa fa-key"></i> License Type
                                  </label>
                                  <select class="form-select modern-input" formControlName="licenseType" id="licenseType">
                                    <option [value]="licenceType.Demo">Demo</option>
                                    <option [value]="licenceType.Standard">Standard</option>
                                    <option [value]="licenceType.Enterprise">Enterprise</option>
                                  </select>
                                  <div *ngIf="licenceUserForm.controls['licenseType'].touched && licenceUserForm.controls['licenseType'].errors?.['required']" class="invalid-feedback d-block">
                                    License Type is required
                                  </div>
                                </div>
                              </div>

                              <!-- Start Date -->
                              <div class="col-md-6">
                                <div class="modern-form-group">
                                  <label for="startDate" class="modern-label">
                                    <i class="fa fa-calendar-plus"></i> Start Date
                                  </label>
                                  <input class="form-control modern-input" type="date" formControlName="startDate" id="startDate" />
                                  <div *ngIf="licenceUserForm.controls['startDate'].touched && licenceUserForm.controls['startDate'].errors?.['required']" class="invalid-feedback d-block">
                                    Start Date is required
                                  </div>
                                </div>
                              </div>

                              <!-- End Date -->
                              <div class="col-md-6">
                                <div class="modern-form-group">
                                  <label for="endDate" class="modern-label">
                                    <i class="fa fa-calendar-check"></i> End Date
                                  </label>
                                  <input class="form-control modern-input" type="date" formControlName="endDate" id="endDate" />
                                  <div *ngIf="licenceUserForm.controls['endDate'].touched && licenceUserForm.controls['endDate'].errors?.['required']" class="invalid-feedback d-block">
                                    End Date is required
                                  </div>
                                </div>
                              </div>

                              <!-- Foreground Color -->
                              <div class="col-md-6">
                                <label class="form-label"><i class="fa fa-palette me-2"></i>Foreground Color</label>
                                <div class="color-picker-group">
                                  <input type="color" class="form-control-color color-swatch" formControlName="forecolor" (change)="onForecolorChange($event)" />
                                  <input type="text" class="form-control color-text-input" formControlName="forecolor" (input)="onColorTextChange('forecolor', $event)" placeholder="#000000" />
                                </div>
                              </div>

                              <!-- Background Color -->
                              <div class="col-md-6">
                                <label class="form-label"><i class="fa fa-fill-drip me-2"></i>Background Color</label>
                                <div class="color-picker-group">
                                  <input type="color" class="form-control-color color-swatch" formControlName="backcolor" (change)="onBackcolorChange($event)" />
                                  <input type="text" class="form-control color-text-input" formControlName="backcolor" (input)="onColorTextChange('backcolor', $event)" placeholder="#FFFFFF" />
                                </div>
                              </div>

                              <!-- Number of Users Slider -->
                              <div class="col-12">
                                <label class="form-label"><i class="fa fa-users me-2"></i>Number of Users: <strong class="text-primary">{{ licenceUserForm.controls['noOfUsers'].value }}</strong></label>
                                <input type="range" class="form-range modern-slider" min="1" max="500" formControlName="noOfUsers" (input)="onSliderChange($event)" />
                              </div>
                    
                              <!-- Is Active -->
                              <div class="col-12 mt-3">
                                <div class="modern-switch-wrapper">
                                  <div class="form-check form-switch modern-switch-inline">
                                    <input class="form-check-input" type="checkbox" formControlName="isActive" id="flexSwitchCheckChecked" />
                                    <label class="form-check-label" for="flexSwitchCheckChecked">
                                      Active License
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </form>
                        </div>
                      
                        <div class="modal-footer">
                          <button class="btn btn-outline-warning btn-modal-action" (click)="cancelForm(modal)">
                            <i class="fa fa-times me-2"></i>Cancel
                          </button>
                          <button type="submit" (click)="onSubmit()" class="btn btn-primary btn-modal-action">
                            <i class="fa fa-check me-2"></i>{{ mode === 'add' ? 'Save' : 'Update' }}
                          </button>
                        </div>
                      </ng-template>
                      <ng-template #initializeDBModal let-modal>
                        <div class="modal-header">
                          <h4 class="modal-title" id="modal-basic-title">
                           SQL Server Connection
                          </h4>
                          <button type="button" class="btn-close" aria-label="Close" (click)="cancelInitializeDbForm(modal)"></button>
                        </div>
                        <div *ngIf="dbInitializePOV == 1">
                          <div class="modal-body">
                            <form class="theme-form" [formGroup]="initializeDbForm">
                              <div class="form-group">
                                <div class="row">
                                  <div class="col-xl-3">
                                    <label class="col-form-label">{{ 'Sql Server Instance:' | translate }}</label>

                                  </div>
                                  <!-- Instances Dropdown -->
                                  <div class="col-xl-6">
                                    <mat-select formControlName="server" id="employeeId" class="custom-mat-select">
                                      <mat-option [value]="0" disabled>{{ 'Select Instance' | translate }}</mat-option>
                                      <!-- <mat-option *ngIf="loadingInstance" disabled>{{ 'Getting Instances...' }}</mat-option> -->
                                      <!-- <mat-option *ngIf="!loadingInstance && sqlInstances.length === 0" disabled>{{ 'No instances available' }}</mat-option> -->
                                      <!-- <mat-option [value]="'DESKTOP-APBIKC7'">DESKTOP-APBIKC7</mat-option> -->
                                      <mat-option *ngFor="let instance of sqlInstances" [value]="instance"> 
                                        {{ instance }}
                                      </mat-option>
                                    </mat-select>
                                    <div *ngIf="initializeDbForm.get('server')?.touched && initializeDbForm.get('server')?.invalid" class="text-danger">
                                      <div *ngIf="initializeDbForm.get('server')?.errors?.['required']">{{ 'Server is required' }}</div>
                                    </div>
                                  </div>
                                  <div class="col-xl-3"><button (click)="getSqlInstances()" class="btn btn-primary">Search</button></div>

                                  </div>
                                  <div class="row">
                                  </div>
                                  <br>
                                  <div class="row">
                                    
                                    <div class="col-xl-3">
                                      <label class="col-form-label">{{ 'Username:' | translate }}</label>
  
                                    </div>
                                  <!-- Username -->
                                  <div class="col-xl-6">
                                    <input (click)="onUsernamePasswordClick('username')" class="form-control" type="text" placeholder="Enter username" formControlName="username" />
                                    <div *ngIf="initializeDbForm.controls['username'].touched && initializeDbForm.controls['username'].errors?.['required']" class="text text-danger mt-1">
                                      Username Required
                                    </div>
                                  </div>
                                  </div>
                                  <br>
                                  <div class="row">
                                    <div class="col-xl-3"><label>Password</label></div>
                                  <!-- Password -->
                                  <div class="col-xl-6">
                                      
                                      <input (click)="onUsernamePasswordClick('password')"  class="form-control" type="text" placeholder="Enter company name" formControlName="password" />
                                      <div *ngIf="initializeDbForm.controls['password'].touched && initializeDbForm.controls['password'].errors?.['required']" class="text text-danger mt-1">
                                        Password Required
                                      </div>
                                    </div>

                                    </div>
                                    <br>
                                    <div class="row">
                                      <div class="col-xl-8"></div>
                                      <div class="col-xl-4">
                                        <button type="button" (click)="testConnection()" class="btn btn-outline-primary">
                                          <i class="fa fa-check"></i> Test Connection
                                        </button>
                                      </div>
                                    </div>
                                    
                                    <br>
                                    <div class="row">
                                      
                                    <div >
                                      
                                      <div class="row" (click)="onDatabaseNameClick()">
                                        <div class="col-xl-3" ><label class="">Database Name</label></div>
                                        <div class="col-xl-6">
                                          
                                          <input class="form-control" (click)="onDatabaseNameClick()"  type="text" placeholder="Enter database name" formControlName="databaseName" >
                                          <div *ngIf="initializeDbForm.controls['databaseName'].touched && initializeDbForm.controls['databaseName'].errors?.['required']" class="text text-danger mt-1">
                                            Database Name is required
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  
                              </div>
                        
                              
                              </div>
                            </form>
                          </div>
                          <!-- modal body end -->
                          <div class="modal-footer">
                            <button class="btn btn-outline-warning" (click)="cancelInitializeDbForm(modal)">
                              <i class="fa fa-times"></i> Cancel
                            </button>
                            
                            <button *ngIf="testConnectionSuccess" type="button" (click)="createDatabase()" class="btn btn-outline-success">
                              <i class="fa fa-database"></i> Create Database
                            </button>
                          </div>
                        </div>
                        <div *ngIf="dbInitializePOV == 2">
                          <div class="modal-body">
                            execute script
                          </div>
                          <!-- modal body end -->
                          <div class="modal-footer">
                            
                            <button type="button" (click)="BackToOne()" class="btn btn-outline-success">
                              <i class="fa fa-arrow-left"></i> Back
                            </button>
                            <button *ngIf="testConnectionSuccess" type="button" (click)="executeScript()" class="btn btn-outline-success">
                              <i class="fa fa-play"></i> Execute Script
                            </button>
                          </div>
                        </div>
                      </ng-template>
                      <ng-template #deleteLicenseContent let-modal>
                        <div class="modal-header delete-modal-header">
                            <h4 class="modal-title" id="modal-basic-title">
                              <i class="fa fa-exclamation-triangle text-warning me-2"></i>
                              Delete Confirmation
                            </h4>
                            <button type="button" class="btn-close" aria-label="Close"
                                (click)="modal.dismiss('Cross click')"></button>
                        </div>
                        <div class="modal-body delete-modal-body">
                            <div class="delete-confirmation-content">
                                <div class="warning-icon-container">
                                    <i class="fa fa-trash-o"></i>
                                </div>
                                <p class="confirmation-text">Are you sure you want to delete this license?</p>
                                <p class="warning-message">This action cannot be undone.</p>
                            </div>
                        </div>
                        <div class="modal-footer delete-modal-footer">
                            <button class="btn btn-modal-action btn-cancel" (click)="modal.dismiss('Cancel')">
                                <i class="fa fa-times me-1"></i>
                                Cancel
                            </button>
                            <button class="btn btn-modal-action btn-delete" (click)="modal.close('Delete')">
                                <i class="fa fa-trash-o me-1"></i>
                                Delete
                            </button>
                        </div>
                    </ng-template>
                    
                    <div class="row justify-content-end margin-top-bottom-for-add">
                        <div class="col-auto">
                            <button (click)="openModalForAdd(licenseContent)" class="btn btn-outline-primary" style="margin: 3px;"
                                ><i class="fa fa-plus"></i> {{'ADD' | translate }}</button>
                            <!-- 
                <button class="btn btn-outline-danger" style="margin: 3px;"
                    (click)="openDeleteModal(deleteDepartmentContent)">Delete</button> -->
                        </div>
                    </div>
                    <br />
                    
                    <!-- Loading State -->
                    <div *ngIf="loadingLicences" class="table-loading-overlay">
                      <div class="loading-container">
                        <div class="spinner-border text-primary me-2" role="status">
                          <span class="visually-hidden">Loading...</span>
                        </div>
                        <span class="loading-text">{{ 'LOADING_LICENCES' | translate }}</span>
                      </div>
                    </div>

                    <div class="custom-datatable noscroll" [class.loading-active]="loadingLicences">
                        <div class="custom-datatable">
                            <table datatable  [dtOptions]="dtOptions" [dtTrigger]="dtTrigger"  class="table" id="table1">
                                <thead>
                                  <tr>
                                    <th scope="col">{{ 'COMPANY_CODE' | translate }}</th>
                                    <th scope="col">{{ 'COMPANY_NAME' | translate }}</th>
                                    <th scope="col">{{ 'EMAIL' | translate }}</th>
                                    <th scope="col">{{ 'NO_OF_USERS' | translate }}</th>
                                    <th scope="col">{{ 'STATUS' | translate }}</th>
                                    <th scope="col">{{ 'LICENCE_TYPE' | translate }}</th>
                                    <th scope="col">{{ 'ACTIONS' | translate }}</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr *ngFor="let user of licenceUsers">
                                    <td>{{ user.companyCode }}</td>
                                    <td>{{ user.companyName }}</td>
                                    <td>{{ user.companyEmail }}</td>
                                    <td>{{ user.noOfUsers }}</td>
                                    
                                    <td title="{{ user.isActive ? ('ACTIVE' | translate) : ('INACTIVE' | translate) }}">
                                      <span class="badge" [ngClass]="user.isActive ? 'badge-success' : 'badge-danger'">
                                        {{ user.isActive ? ('ACTIVE' | translate) : ('INACTIVE' | translate) }}
                                      </span>
                                    </td>
                                    <td>{{ getLicenceType(user.licenseType) }}</td>
                                    <td>
                                      <div class="row">
                                        <div class="col-sm-6">
                                          <div ngbDropdown class="d-inline-block" placement="bottom">
                                            <button class="btn btn-outline-primary" id="dropdownBasic1" ngbDropdownToggle>Action</button>
                                            <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                                              <button class="dropdown-item" (click)="openModalForEdit(user, licenseContent)">{{ 'EDIT' | translate }}</button>
                                              <button class="dropdown-item" (click)="deleteLicenceUser(deleteLicenseContent, user)">{{ 'DELETE' | translate }}</button>
                                            </div>
                                          </div>
                                        </div>
                                        
                                      </div>
                                      <div class="row mt-1">
                                        <!-- <div class="col-sm-12">
                                          <button class="btn btn-primary btn-sm" (click)="openDbInitializeModal(user, initializeDBModal)" style="font-size: 12px !important;margin-top: 1%;">{{ 'INITIALIZE_DATABASE' | translate }}</button>    

                                        </div> -->
                                      </div>
                                      <!-- Dropdown Container -->
                        
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                              
                            <div class="d-flex justify-content-between p-2">

                            </div>
                        </div>
                    </div>




                </div>
            </div>
        </div>
    </div>
</div>
<!-- Container-fluid Ends-->